import React from 'react';
import { motion } from 'framer-motion';
import HeroV2 from '../components/HeroV2';
import TechStackV2 from '../components/TechStackV2';
import SystemsBuiltV2 from '../components/SystemsBuiltV2';
import ArchitectureCaseStudiesV2 from '../components/ArchitectureCaseStudiesV2';
import SystemDesignV2 from '../components/SystemDesignV2';
import PerformanceEngineeringV2 from '../components/PerformanceEngineeringV2';
import ProjectsV2 from '../components/ProjectsV2';
import ExperienceV2 from '../components/ExperienceV2';
import SkillsV2 from '../components/SkillsV2';
import OpenSourceV2 from '../components/OpenSourceV2';
import ContactV2 from '../components/ContactV2';
import FooterV2 from '../components/FooterV2';

const PortfolioV2 = () => {
  const sections = [
    <HeroV2 />,
    <TechStackV2 />,
    <SystemsBuiltV2 />,
    <ArchitectureCaseStudiesV2 />,
    <SystemDesignV2 />,
    <PerformanceEngineeringV2 />,
    <ProjectsV2 />,
    <ExperienceV2 />,
    <SkillsV2 />,
    <OpenSourceV2 />,
    <ContactV2 />,
  ];

  return (
    <div className="min-h-screen bg-white">
      <main>
        {sections.map((section, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: index * 0.04 }}
            viewport={{ once: true, amount: 0.15 }}
          >
            {section}
          </motion.div>
        ))}
        <FooterV2 />
      </main>
    </div>
  );
};

export default PortfolioV2;
